// extracted by css-extract-rspack-plugin
export default {"container":"_ec0a9602"};